import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomModal, InputText } from '../../../../components'
import { updateDeliveryIdentifierAndInvoiceNumberByTp } from '../../../../services/api/https/deliveries/delivery.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Alterando NF/Identificador',
  SUCCESS: 'NF/Identificador alterado com sucesso',
}

const INITIAL_STATE = {
  delivery: null,
  identifier: '',
  invoice_number: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const { id: user_id } = getUsuarioInfo()

function ModalAlterarNfIdentificador({ data, show, tpId, onModalClose, onModalSave, dispatch }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (!show || !data) {
      setState({ ...INITIAL_STATE })
      return
    }

    setState({
      delivery: data,
      identifier: data.identifier || '',
      invoice_number: data.invoice_number || '',
      loadingMessage: LOAD_MESSAGE.NONE,
      errorMessage: null,
    })
  }, [show, data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        salvarAlteracao()
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave({
          ...state.delivery,
          identifier: state.identifier.trim(),
          invoice_number: state.invoice_number.trim(),
        })
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (!state.errorMessage) return

    dispatch(showMessageBox(null, state.errorMessage))
    setState(prevState => ({
      ...prevState,
      loadingMessage: LOAD_MESSAGE.NONE,
      errorMessage: null,
    }))
  }, [state.errorMessage])

  const salvarAlteracao = async () => {
    try {
      const identifier = state.identifier.trim()
      const invoice_number = state.invoice_number.trim()

      await updateDeliveryIdentifierAndInvoiceNumberByTp(tpId, {
        delivery_id: state.delivery.delivery_id,
        identifier,
        invoice_number,
        user_id,
      })

      setState(prevState => ({
        ...prevState,
        identifier,
        invoice_number,
        loadingMessage: LOAD_MESSAGE.SUCCESS,
      }))
    } catch (error) {
      setState(prevState => ({
        ...prevState,
        errorMessage: errorHandler(error),
        loadingMessage: LOAD_MESSAGE.NONE,
      }))
    }
  }

  const onBtnSalvarClicked = () => {
    const identifier = state.identifier.trim()
    const currentIdentifier = state.delivery ? state.delivery.identifier || '' : ''
    const currentInvoiceNumber = state.delivery ? state.delivery.invoice_number || '' : ''
    const invoiceNumber = state.invoice_number.trim()

    if (!identifier) {
      dispatch(showMessageBox(null, 'Insira um identificador ou identificador e n° NF válido'))
      return
    }

    if (currentInvoiceNumber && !invoiceNumber) {
      dispatch(showMessageBox(null, 'Insira um identificador ou identificador e n° NF válido'))
      return
    }

    if (identifier === currentIdentifier && invoiceNumber === currentInvoiceNumber) {
      dispatch(showMessageBox(null, 'Insira um identificador ou identificador e n° NF válido'))
      return
    }

    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  return (
    <CustomModal
      header="Alterar NF/Identificador"
      isVisible={show}
      onClose={onModalClose}
      width={650}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Identificador"
            value={state.identifier}
            onChange={value => setState(prevState => ({ ...prevState, identifier: value }))}
          />
        </div>
        <div className="p-col-12">
          <InputText
            label="N° NF"
            value={state.invoice_number}
            onChange={value => setState(prevState => ({ ...prevState, invoice_number: value }))}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalAlterarNfIdentificador)
